export enum BudgetAggregate {
  Team = 'Team',
  Project = 'Project',
  Client = 'Client',
  ClientProject = 'ClientProject',
  ClientPhaseParent = 'ClientPhaseParent',
  ClientPhase = 'ClientPhase',
  ClientPhaseActivity = 'ClientPhaseActivity',
  PhaseParent = 'PhaseParent',
  Phase = 'Phase',
  PhaseActivity = 'PhaseActivity',
  Account = 'Account',
  AccountProject = 'AccountProject',
  AccountPhaseParent = 'AccountPhaseParent',
  AccountPhase = 'AccountPhase',
  AccountPhaseActivity = 'AccountPhaseActivity',
  AccountPosition = 'AccountPosition',
  AccountPositionProject = 'AccountPositionProject',
  AccountPositionPhaseParent = 'AccountPositionPhaseParent',
  AccountPositionPhase = 'AccountPositionPhase',
  AccountPositionPhaseActivity = 'AccountPositionPhaseActivity',
  Position = 'Position',
  PositionProject = 'PositionProject',
  PositionPhaseParent = 'PositionPhaseParent',
  PositionPhase = 'PositionPhase',
  PositionPhaseActivity = 'PositionPhaseActivity',
}

export enum BudgetAggregateIntervalType {
  Month = 'months',
  Week = 'weeks',
}
